module.exports = __webpack_public_path__ + "static/media/HCMM840.413fa7e1.jpg";